var React = require('react');

function IconFolderO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M840.472 435.768H155.398c-14.636 0-26.5-11.864-26.5-26.5s11.864-26.5 26.5-26.5h685.074c14.636 0 26.5 11.864 26.5 26.5s-11.864 26.5-26.5 26.5z","key":0}),React.createElement("path",{"d":"M840.472 264.123H739.73c-14.636 0-26.5 11.864-26.5 26.5s11.864 26.5 26.5 26.5h74.242V800.05H181.898V198.149l185.737-.348 111.561 111.561a26.5 26.5 0 0 0 18.738 7.762h128.799c14.636 0 26.5-11.864 26.5-26.5s-11.864-26.5-26.5-26.5H508.912L397.33 152.542a26.5 26.5 0 0 0-18.738-7.762h-.05l-223.193.418c-14.616.027-26.45 11.884-26.45 26.5V826.55c0 14.636 11.864 26.5 26.5 26.5h685.074c14.636 0 26.5-11.864 26.5-26.5V290.623c-.001-14.635-11.865-26.5-26.501-26.5z","key":1})]);
}

IconFolderO.displayName = "IconFolderO";

IconFolderO.defaultProps = {"viewBox":"0 0 1000.636 1000.678"};

module.exports = IconFolderO;

IconFolderO.default = IconFolderO;
